module.exports = __webpack_public_path__ + "img/Truppführer_O.b360d7ab.svg";